// Copyright (c) 2016 Deere & Company

import './components-item.scss';
import React, {PropTypes} from 'react';
import Component from '@deere/cps-it.warranty-model-factory/lib/component';
import ProductLink from '../../shared/components/product-link';
import {buildDate} from '../../../shared/services/build-date';

function handleOnClick() {

    this.onDelete(this.component.id);

}

const ComponentsItem = props =>
    <section className='components-item'>
        <div className='components-item-row'>
            <span className='serial-number-item'>
                {props.component.isPin ?
                    <ProductLink
                        pin={props.component.serialNumber}
                        productLinkStyle=''
                        productLinkText={props.component.serialNumber}
                        rel='noopener noreferrer'
                        target='_blank'
                        translate={false}
                    /> :
                        <span>
                            {props.component.serialNumber}
                        </span>
                }
            </span>
            <span className='description-item'>
                {props.component.description}
            </span>
            <span className='code-item'>
                {props.component.code}
            </span>
            <span className='created-date-item'>
                {buildDate(props.component.createdDate)}
            </span>
            <span className='changed'>
                {buildDate(props.component.changedDate)}
            </span>
            <span className='changed-by'>
                {props.component.changedBy.id}
            </span>
            {props.component.canBeDeleted && props.canAddDeleteComponent &&
                <span
                    className='icon-trash-can'
                    onClick={props::handleOnClick}
                />
            }
        </div>
    </section>;

ComponentsItem.displayName = 'ComponentItem';
ComponentsItem.propTypes = {
    canAddDeleteComponent: PropTypes.bool.isRequired,
    component: PropTypes.instanceOf(Component).isRequired,
    onDelete: PropTypes.func.isRequired
};

export default ComponentsItem;



// WEBPACK FOOTER //
// ./src/product/details/components/components-item.js